// React
import { CSSProperties, useState } from "react";

// MUI
import { Grid, Skeleton } from "@mui/material";

//Component
import SmallActionButtonCustom from "./SmallActionButtonCustom";

type SmallActionButtonProps = {
	buttonText?: string;
	buttonTextConfirm?: string;
	description?: string;
	disabled?: boolean;
	loading?: boolean;
	onClick: () => void;
	style?: CSSProperties;
	btnContainerStyle?: CSSProperties;
};
export default function SmallActionButton(props: Readonly<SmallActionButtonProps>) {
	const [deleting, setDeleting] = useState(false);

	const handleOnclick = () => {
		props.onClick();
	};

	return (
		<Grid container direction={"row"} justifyContent={"flex-end"} style={props.btnContainerStyle}>
			{!deleting && props.description && (
				<Grid item className="font-sans text-strong-gray text-[14.5px] font-medium normal-case pt-[2px]" style={props.style}>
					{props.loading ? <Skeleton width={135} /> : props.description}
				</Grid>
			)}
			<Grid item className="!transition-all !duration-1000 !ease-in-out">
				<SmallActionButtonCustom
					buttonText={props.buttonText}
					buttonTextConfirm={props.buttonTextConfirm}
					disabled={props.disabled}
					loading={props.loading}
					deleting={deleting}
					setDeleting={setDeleting}
					handleOnclick={handleOnclick}
				/>
			</Grid>
		</Grid>
	);
}
